export const BATERIA_CATEGORIAS = [
  { value: "rack_48v", label: "Rack 48 V" },
  { value: "alta_tensao_modular", label: "Módulo alta tensão / stack" },
  { value: "outro", label: "Outro" },
] as const;

export type BateriaCategoriaArquitetural = (typeof BATERIA_CATEGORIAS)[number]["value"];

export function labelCategoriaBateria(categoria: string): string {
  const found = BATERIA_CATEGORIAS.find((c) => c.value === categoria);
  return found?.label ?? categoria;
}

export interface Bateria {
  id: string;
  marca: string;
  modelo: string;
  tipoCelula: string;
  categoriaArquitetural: BateriaCategoriaArquitetural;
  tensaoNominalV: number;
  capacidadeNominalAh: number | null;
  energiaKwh: number;
  potenciaNominalKw: number | null;
  correnteMaxCargaA: number | null;
  correnteMaxDescargaA: number | null;
  tensaoOperacaoMinV: number | null;
  tensaoOperacaoMaxV: number | null;
  dimensoes: {
    comprimento: number;
    largura: number;
    altura: number;
  };
  pesoKg: number;
  ciclosUteis80Dod: number | null;
  garantiaAnos: number;
  observacoes: string | null;
  imagemUrl?: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface CreateBateria {
  marca: string;
  modelo: string;
  tipoCelula: string;
  categoriaArquitetural: BateriaCategoriaArquitetural;
  tensaoNominalV: number;
  capacidadeNominalAh: number | null;
  energiaKwh: number;
  potenciaNominalKw: number | null;
  correnteMaxCargaA: number | null;
  correnteMaxDescargaA: number | null;
  tensaoOperacaoMinV: number | null;
  tensaoOperacaoMaxV: number | null;
  dimensoes: {
    comprimento: number;
    largura: number;
    altura: number;
  };
  pesoKg: number;
  ciclosUteis80Dod: number | null;
  garantiaAnos: number;
  observacoes: string | null;
  imagemUrl?: string | null;
}

export type UpdateBateria = Partial<CreateBateria>;
